import { Menu } from 'primereact/menu';
import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import './Header.scss';
import { hasPermission, isLogged } from '../../utils/common';
import CONSTANT from '../../utils/constant';
import { cloneDeep, findIndex } from 'lodash';

export default function Header() {
  const [accountMenuItems, setAccountMenuItems] = useState<any>([]);

  const navigate = useNavigate();
  const user = useSelector((state: any) => state.auth.user);

  const accountMenuRef = useRef<any>(null);
  const accountMenuItemsRef = useRef<any>([
    {
      label: 'TÀI KHOẢN CỦA TÔI',
      command: () => navigate('/tt-tai-khoan'),
    },
    {
      label: 'ĐĂNG XUẤT',
      command: () => navigate('/logout'),
    },
  ]);

  useEffect(() => {
    if (user && hasPermission(user, CONSTANT.SYSTEM_ROLES.QUAN_TRI_HE_THONG)) {
      if (findIndex(accountMenuItemsRef.current, { label: 'QUẢN LÝ DS TÀI KHOẢN' }) === -1) {
        accountMenuItemsRef.current = [
          {
            label: 'QUẢN LÝ DS TÀI KHOẢN',
            command: () => navigate('/quan-ly-tai-khoan'),
          },
          ...accountMenuItemsRef.current,
        ];
        console.log('accountMenuItemsRef.current', user, accountMenuItemsRef.current);
        setAccountMenuItems(cloneDeep(accountMenuItemsRef.current));
      }
    }
  }, [user]);

  return (
    <div className="header fixed top-0 right-0 z-10 left-0 h-header flex items-center justify-between px-5 bg-white shadow">
      <div className="flex items-center">
        <Link to="/" className="h-header flex items-center">
          <img src="/logo_wobg.png" className="w-30 h-12" alt="" />
        </Link>
      </div>
      {isLogged(user) && (
        <div className="menu-list hidden sm:block">
          <NavLink className="p-button mr-2" to="/tai-xe">
            DS TÀI XẾ
          </NavLink>
          <NavLink className="p-button mr-2" to="/don-hang-tx">
            ĐẶT ĐƠN CHO TX
          </NavLink>
          <NavLink className="p-button mr-2" to="/lich-trinh-tx">
            LỊCH TRÌNH TX
          </NavLink>
          <NavLink className="p-button mr-2" to="/khach-hang">
            DS KHÁCH HÀNG
          </NavLink>
          <NavLink className="p-button mr-2" to="/don-hang-kh">
            ĐẶT ĐƠN CHO KH
          </NavLink>
          <NavLink className="p-button mr-2" to="/van-hanh-don">
            VẬN HÀNH ĐƠN
          </NavLink>
          {/* {hasPermission(user, CONSTANT.SYSTEM_ROLES.QUAN_TRI_HE_THONG) && (
            <NavLink className="p-button mr-2" to="/quan-ly-tai-khoan">
              QUẢN LÝ TÀI KHOẢN
            </NavLink>
          )} */}
        </div>
      )}
      <div className="flex items-center min-w-max">
        <div className="flex items-center">
          <Menu
            model={accountMenuItems}
            popup
            ref={accountMenuRef}
            id="popup_menu_right"
            popupAlignment="right"
            // onClick={handleMenuClick}
          />
          <div className="cursor-pointer" onClick={(event) => accountMenuRef.current.toggle(event)}>
            <i className="pi pi-user border-2 rounded-full p-3 border-red-600"></i>
            <span className="underline underline-offset-2 ml-2">{user?.full_name || user?.nickname}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
